var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"confirmation-dialog","title":_vm.title,"ok-title":"Proceed","no-close-on-backdrop":true},on:{"ok":_vm.handleOk}},[_c('div',{staticClass:"confirmMessage"},[_vm._v(" You have unsave changes to this page. Are you sure you want leave? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }